import React, { createContext } from 'react';
import { CustomAlarmListItem } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/settings-devices-custom-alarm-list.model';

export interface CustomAlarmsListContextProps {
    selectedRows: CustomAlarmListItem[];
    setSelectedRows: React.Dispatch<React.SetStateAction<CustomAlarmListItem[]>>;
    isLoading: boolean;
    customAlarms: CustomAlarmListItem[];
    fetchList: VoidFunction;
    setCustomAlarms: React.Dispatch<React.SetStateAction<CustomAlarmListItem[]>>;
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
    onlyActive: boolean;
    handleOnlyActiveChange: (newValue: boolean) => void;
}

export const CustomAlarmsListContext = createContext<CustomAlarmsListContextProps | undefined>(undefined);
